import React from 'react';
import { Row, Col } from 'antd';
import { Header } from './Header';
import { TableList } from './TableList';
import { useDataExtractionContext } from '@/context/DataExtraction';

export function Content() {
	const { gutterLayout } = useDataExtractionContext();

	return (
		<Row gutter={gutterLayout}>
			<Col span={24}>
				<Header />
			</Col>
			<Col span={24}>
				<TableList />
			</Col>
		</Row>
	);
}
